module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "floatmenu-box"
  }, [(_vm.showMiddle) ? _c('div', {
    directives: [{
      name: "fixpos",
      rawName: "v-fixpos",
      value: ({
        pos: 'right',
        default: '0.2rem'
      }),
      expression: "{ pos: 'right', default: '0.2rem' }"
    }],
    staticClass: "new-order-btn"
  }, [_c('a', {
    directives: [{
      name: "burypoint",
      rawName: "v-burypoint",
      value: ({
        events: 'zxkf',
        page: _vm.parentpage,
        isChildComponents: true,
        oldPropName: _vm.acceptName
      }),
      expression: "{ events: 'zxkf', page: parentpage, isChildComponents: true, oldPropName: acceptName }"
    }],
    staticClass: "service",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showNewOrder = true
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "line"
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "burypoint",
      rawName: "v-burypoint",
      value: ({
        events: 'wddd',
        page: _vm.parentpage,
        isChildComponents: true,
        oldPropName: _vm.acceptName
      }),
      expression: "{ events: 'wddd', page: parentpage, isChildComponents: true, oldPropName: acceptName }"
    }],
    staticClass: "order",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.goMyOrder()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNewOrder),
      expression: "showNewOrder"
    }],
    staticClass: "baziTispHover",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showNewOrder = false
      }
    }
  }, [_c('div', {
    staticClass: "Toast"
  }, [_c('img', {
    staticClass: "close_btn",
    attrs: {
      "src": require("./_img/glb_msg_close.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showNewOrder = false
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wxNumber"
  }, [_c('img', {
    attrs: {
      "src": require("./_img/glb_micMsg.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.wx))])]), _vm._v(" "), _c('div', {
    staticClass: "copyWx"
  }, [_c('span', {
    directives: [{
      name: "burypoint",
      rawName: "v-burypoint",
      value: ({
        events: 'fzhm',
        page: _vm.parentpage,
        isChildComponents: true,
        oldPropName: _vm.acceptName
      }),
      expression: "{ events: 'fzhm', page: parentpage, isChildComponents: true, oldPropName: acceptName }"
    }],
    staticClass: "wxCode",
    attrs: {
      "data-clipboard-text": _vm.wx
    },
    on: {
      "click": function($event) {
        return _vm.CopyWechat()
      }
    }
  }, [_vm._v("复制号码")])])])]), _vm._v(" "), (_vm.showTop) ? _c('a', {
    directives: [{
      name: "fixpos",
      rawName: "v-fixpos",
      value: ({
        pos: 'right',
        default: '0.2rem'
      }),
      expression: "{ pos: 'right', default: '0.2rem' }"
    }, {
      name: "burypoint",
      rawName: "v-burypoint",
      value: ({
        events: 'gdcs',
        page: _vm.parentpage,
        isChildComponents: true,
        oldPropName: _vm.acceptName
      }),
      expression: "{ events: 'gdcs', page: parentpage, isChildComponents: true, oldPropName: acceptName }"
    }],
    staticClass: "home-index-btn",
    on: {
      "click": _vm.toHome
    }
  }, [_vm._v("\n    更多测算\n  ")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tisp"
  }, [_c('span', {
    staticClass: "red_color"
  }, [_vm._v("添加客服")]), _vm._v("咨询，同时您将获得"), _c('span', {
    staticClass: "red_color"
  }, [_vm._v("大师为您亲自测算")]), _vm._v("一生财运、事业运、一生感情运...\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-448892b8","hasScoped":true}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/floatmenu.vue
// module id = Lgua
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14